export default __webpack_public_path__ + "static/media/bg.5f66c44e.jpg";